<template>
    <div class="publication__filters content-width">

        <div class="d-flex">

            <div class="publication__section-inner d-flex">

                <div class="publication__section-item">
                    <div class="publication__section-title">Животное-донор?</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in filtersServer.default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.is_donor.$model" :value="item.value">
                                <span class="circle"></span>
                                {{item.name}}
                            </label>
                        </div>
                    </div>
                    <div class="text-danger" v-if="$v.is_donor.$error" >Неверное значение.</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">Вес питомца</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in filtersServer.dictionaries.weight">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.weight.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>
                    <div class="text-danger" v-if="$v.weight.$error">Укажите вес.</div>
                </div>
            </div>

        </div>

        <div class="publication__filters-row">

            <div class="publication__filters-title">
                Социальные артибуты
            </div>

            <div class="publication__social d-flex">

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_children', value: to_children}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_children)" >{{`${to_children}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Отношение к детям
                    </div>

                    <div class="text-danger" v-if="$v.to_children.$error">Неверное значение</div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_cats', value: to_cats}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_cats)" >{{`${to_cats}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Отношение к котам
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'to_dogs', value: to_dogs}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(to_dogs)" >{{`${to_dogs}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Отношение к собакам
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'enrichment', value: enrichment}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(enrichment)" >{{`${enrichment}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Условия жизни
                    </div>

                </div>

                <div class="publication__social-item">
                    <div class="publication__social-icon">
                        <star :target="{name: 'human_sociability', value: human_sociability}" @handleSocial="handleSocial"/>
                        <span v-if="parseInt(human_sociability)" >{{`${human_sociability}.0`}}</span>
                    </div>
                    <div class="publication__social-name">
                        Социальность
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>


import { required, requiredIf} from 'vuelidate/lib/validators';

const initialData = {
    default_temp:   [ { value: 1, name: 'Да' }, { value: 0, name: 'Нет' } ],
}

import Star from '../PublicationSocialStar';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PersonalFilters",
    props: ['server'],
    components: { Star },
    mixins: [StateMixin],
    computed: {

        filtersServer(){
            return {
                default_temp: initialData.default_temp,
                dictionaries: this.server.dictionaries
            }
        },

        weight: {
            get() { return this.GET_BY_KEY('weight') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'weight', data: val})
            }
        },

        is_donor: {
            get() { return this.GET_BY_KEY('is_donor') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'is_donor', data: val})
            }
        },

        to_children: {
            get() { return this.GET_BY_KEY('to_children') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_children', data: val })
            }
        },

        to_dogs: {
            get() { return this.GET_BY_KEY('to_dogs') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_dogs', data: val || 'null'})
            }
        },

        to_cats: {
            get() { return this.GET_BY_KEY('to_cats') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'to_cats', data: val || 'null'})
            }
        },

        human_sociability: {
            get() { return this.GET_BY_KEY('human_sociability') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'human_sociability', data: val || 'null'})
            }
        },

        enrichment: {
            get() { return this.GET_BY_KEY('enrichment') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'enrichment', data: val || 'null'})
            }
        },



    },

    methods: {

        handleSocial({ target, rate }){
            this[target] = rate;
        },

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true
        }
    },

    validations: {
        is_donor:    { required },
        to_children: { required },
        weight:      { required },
    }


}
</script>

<style scoped>

</style>
